import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import { listItemMsg } from './FormattedListValue';

export const getResourceName = (intl, resource, withoutCode = false) => {
  if (!intl || !intl.formatMessage || !resource || !resource.id) return null;
  const { categoryId, categoryName, code, id, name, isDefault = false } = resource;
  const codePrefix = code && !withoutCode ? `${code} – ` : '';

  if (categoryId) {
    const categoryTranslation = intl.formatMessage(
      listItemMsg('resourcecategory', categoryId, categoryName),
    );
    if (isDefault) return `${codePrefix}${categoryTranslation}`;
    const resourceTranslation = intl.formatMessage(listItemMsg('resource', id, name));
    return `${codePrefix}${categoryTranslation}: ${resourceTranslation}`;
  }
  const resourceTranslation = intl.formatMessage(listItemMsg('resource', id, name));
  return `${codePrefix}${resourceTranslation}`;
};

export const getResourceNameMapper = (intl, withoutCode = false) => resource =>
  getResourceName(intl, resource, withoutCode);

class ResourceName extends PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
    resource: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      code: PropTypes.string,
      categoryId: PropTypes.string.isRequired,
      categoryName: PropTypes.string.isRequired,
      isDefault: PropTypes.bool,
    }),
    hideCode: PropTypes.bool,
  };
  static defaultProps = {
    resource: null,
    hideCode: false,
  };

  render() {
    const { intl, resource, hideCode, ...rest } = this.props;

    if (resource === null) return null;

    return <span {...rest}>{getResourceName(intl, resource, hideCode)}</span>;
  }
}

export default injectIntl(ResourceName);
